module.exports = __webpack_public_path__ + "static/media/logo-big.ed36abf4.svg";